/* eslint-disable complexity */
/* eslint-disable sonarjs/no-duplicate-string */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Col from '@tcp/core/src/components/common/atoms/Col';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty.js';
import { getLocator, getViewportInfo, isClient } from '@tcp/core/src/utils';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/orderLedger.style';
import CollapsibleContainer from '../../../../../../common/molecules/CollapsibleContainer';
import OrderLedgerUtils, { renderLoyaltyBanner } from './orderLedger.util';
import FreeShippingBanner from '../../../../FreeShippingBanner';
import { SPC_SECTION_TRANSITION_CONFIG } from '../../../../../../common/molecules/AccordionCard/hooks/useAccordionTransition.constants';
import { SPC_SECTION } from '../../../../SinglePageCheckout/container/SinglePageCheckout.constants';
import orderLedgerLabels, { CHECKOUT_LABELS } from './orderLedger.labels';
import {
  GlobalGenericLabels,
  GLOBAL_GENERIC_LABELS,
  lblDetails,
} from '../../../../../../../utils/labels/globalGeneric.labels';

const getIsMobileView = (viewPortInfo) => viewPortInfo && isClient() && viewPortInfo.isMobile;

const getHeader = (ledgerSummaryData, spc, isConfirmationPage, isEstimatedTaxFormEnabledSpc) => {
  const {
    currencySymbol,
    orderBalanceTotal,
    taxesTotal,
    subTotal,
    shippingTotal,
    giftServiceTotal,
    giftCardsTotal,
    couponsTotal,
    savingsTotal,
  } = ledgerSummaryData;
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, orderLedgerLabels);
  const estimatedTotal =
    subTotal +
    taxesTotal +
    shippingTotal +
    giftServiceTotal -
    giftCardsTotal -
    couponsTotal -
    savingsTotal;
  return (
    <div className={`order-ledger-header ${spc ? '' : 'elem-mb-SM'}`}>
      <BodyCopy
        fontFamily="secondary"
        fontSize="fs16"
        fontWeight="semibold"
        component="span"
        data-locator={getLocator('order_ledger_summary_header')}
      >
        {spc ? (
          <div className="spc-header spc-card-heading">
            <BodyCopy fontWeight="semibold" component="span" className="summary-heading">
              {checkoutLabels.bagPage?.lbl_orderledger_title}
            </BodyCopy>
            {!isConfirmationPage && ( // added condition to hide in confirmation page
              <BodyCopy
                fontWeight="semibold"
                component="span"
                className={`header-total ${spc ? 'order-summary-action' : ''}`}
              >
                <span className="order-summary-header-price">
                  {`${currencySymbol}${
                    isEstimatedTaxFormEnabledSpc
                      ? estimatedTotal.toFixed(2)
                      : orderBalanceTotal && orderBalanceTotal.toFixed(2)
                  }`}
                </span>
                <span className="order-summary-header-title">
                  {`${getLabelFromCopyOrFromTranslation(
                    `${GLOBAL_GENERIC_LABELS}.${lblDetails}`,
                    GlobalGenericLabels
                  )}:`}
                </span>
              </BodyCopy>
            )}
          </div>
        ) : (
          `${checkoutLabels.bagPage?.lbl_orderledger_title} (${currencySymbol}${
            orderBalanceTotal && orderBalanceTotal.toFixed(2)
          })`
        )}
      </BodyCopy>
    </div>
  );
};
const getFlag = (isABTestLoaded, isStickyCheckoutButtonEnabled, isMobileView, isShowPlccView) => {
  return (isABTestLoaded && isStickyCheckoutButtonEnabled && isMobileView) || isShowPlccView;
};

const renderPlccBanner = (className, newBag, pageCategory) => {
  return (
    <div className="ledgerForMobile">
      <div className={`${className} ${newBag ? 'rounded-container' : ''} elem-mb-MED new-ledger`}>
        <Col
          colSize={{
            large: 12,
            medium: 8,
            small: 6,
          }}
          ignoreGutter={{ small: true }}
        >
          {pageCategory === 'bagPage' && <FreeShippingBanner />}
          {renderLoyaltyBanner(pageCategory)}
        </Col>
      </div>
    </div>
  );
};

const OrderLedger = ({
  className,
  ledgerSummaryData,
  showAccordian,
  confirmationPageLedgerSummaryData,
  isConfirmationPage,
  orderLedgerAfterView,
  pageCategory,
  bagLoading,
  isVenmoPaymentInProgress,
  venmoPayment,
  spc,
  spcBag,
  isCollapseDisabled,
  isCartLoading,
  newBag,
  isStickyCheckoutButtonEnabled,
  isABTestLoaded,
  getEstimatedTaxAction,
  getIsFromEstimatedTaxForm,
  isEstimatedTaxFormEnabled,
  isEstimatedTaxFormEnabledSpc,
  zipCode,
  zipCodeTaxError,
  isTaxCalculated,
  isInternationalShipping,
  currencyAttributes,
  orderType,
  storeAdress,
  isLoggedIn,
  userContactInfo,
  isPlccCheckoutEnabled,
  userName,
  isPlccCheckoutEnabledSwitch,
  isPlccIsShippingAddressModalOpenAtn,
  IsPlccICAddressModalOpen,
  handlePlccCheckout,
  userShippingAddress,
  rememberedUserFlag,
  taxFromDefaultShippingAddress,
  bossGCAndPreOrderCase,
  verifyAllExpiredCoupons,
  userDefaultStore,
  updateStoreItem,
  productItems,
  bossAndPreOrder,
  bossAndGC,
  resetEDDCall,
  trackAnalyticClick,
  isNonCacheDataLoaded,
  plccShippingAddressUpdateActn,
  containsExtendedOrder,
  isPlccICPickupModalOpenAtn,
  isPlccICPickupModalOpen,
  orderDetails,
  isLoginV2FlowEnabled,
  isHasPickUpAlternatePerson,
  isPlccShippingAddressUpdated,
  isAddToBagInProgress,
  isPlacePerkEnabled,
  nonCacheBagLoading,
  renderCondForPLCCTopBanner,
  freeShippingMessagingEnabled,
  defaultAddressForRemUser,
  plccICForRemberedUser,
  plccLoginModalState,
  togglePlccModalStateAction,
  freeShippingThreshold,
  isFreeShippingLedgerMessageEnabled,
  freeShippingThresholdValue,
  orderSubtotalEnhancementEnabled,
  productTotal,
  productTotalConfirmation,
  bossInEligible,
  isFreeShippingCouponApplied,
  freeShippingPromoType,
  updateSectionStateAtn,
  shipments,
  orderTrackingEnhancementEnabled,
  // eslint-disable-next-line sonarjs/cognitive-complexity
}) => {
  const checkoutLabels = getLabelFromCopyOrFromTranslation(CHECKOUT_LABELS, orderLedgerLabels);
  let summaryData = ledgerSummaryData;
  if (isConfirmationPage) {
    summaryData = confirmationPageLedgerSummaryData;
  }
  const viewPortInfo = getViewportInfo();
  const isMobileView = getIsMobileView(viewPortInfo);
  const containerClass = spcBag ? 'rounded-container' : '';
  const { isDesktop = true } = getViewportInfo() || {};
  const defaultOpen = spc ? isDesktop : true;
  const isShowPlccView = isMobileView && isPlccCheckoutEnabled;
  const isShowLoyaltyBanner = getFlag(
    isABTestLoaded,
    isStickyCheckoutButtonEnabled,
    isMobileView,
    isShowPlccView
  );

  const header = useMemo(
    () => getHeader(summaryData, spc, isConfirmationPage, isEstimatedTaxFormEnabledSpc),
    [ledgerSummaryData, spc]
  );

  const body = useMemo(
    () =>
      OrderLedgerUtils.getBody({
        className,
        summaryData,
        pageCategory,
        orderLedgerAfterView,
        bagLoading,
        isConfirmationPage,
        isVenmoPaymentInProgress,
        venmoPayment,
        spc,
        resetEDDCall,
        isNonCacheDataLoaded,
        isCartLoading,
        isShowLoyaltyBanner,
        getEstimatedTaxAction,
        taxFromDefaultShippingAddress,
        getIsFromEstimatedTaxForm,
        isEstimatedTaxFormEnabled,
        isEstimatedTaxFormEnabledSpc,
        zipCode,
        zipCodeTaxError,
        isTaxCalculated,
        isInternationalShipping,
        currencyAttributes,
        orderType,
        storeAdress,
        isLoggedIn,
        userContactInfo,
        isPlccCheckoutEnabled,
        userName,
        isPlccCheckoutEnabledSwitch,
        isPlccIsShippingAddressModalOpenAtn,
        userShippingAddress,
        IsPlccICAddressModalOpen,
        handlePlccCheckout,
        rememberedUserFlag,
        bossGCAndPreOrderCase,
        verifyAllExpiredCoupons,
        userDefaultStore,
        updateStoreItem,
        productItems,
        bossAndPreOrder,
        bossAndGC,
        isShowPlccView,
        trackAnalyticClick,
        plccShippingAddressUpdateActn,
        containsExtendedOrder,
        isPlccICPickupModalOpenAtn,
        isPlccICPickupModalOpen,
        orderDetails,
        isLoginV2FlowEnabled,
        isHasPickUpAlternatePerson,
        isPlccShippingAddressUpdated,
        isAddToBagInProgress,
        nonCacheBagLoading,
        isStickyCheckoutButtonEnabled,
        renderCondForPLCCTopBanner,
        checkoutLabels,
        freeShippingMessagingEnabled,
        defaultAddressForRemUser,
        plccICForRemberedUser,
        plccLoginModalState,
        togglePlccModalStateAction,
        freeShippingThreshold,
        isFreeShippingLedgerMessageEnabled,
        freeShippingThresholdValue,
        orderSubtotalEnhancementEnabled,
        productTotal,
        productTotalConfirmation,
        bossInEligible,
        isFreeShippingCouponApplied,
        freeShippingPromoType,
        updateSectionStateAtn,
        shipments,
        orderTrackingEnhancementEnabled,
      }),
    [
      className,
      summaryData,
      pageCategory,
      orderLedgerAfterView,
      bagLoading,
      isConfirmationPage,
      isVenmoPaymentInProgress,
      venmoPayment,
      spc,
      isCartLoading,
      isStickyCheckoutButtonEnabled,
      isABTestLoaded,
      getEstimatedTaxAction,
      getIsFromEstimatedTaxForm,
      isEstimatedTaxFormEnabled,
      isEstimatedTaxFormEnabledSpc,
      zipCode,
      zipCodeTaxError,
      isTaxCalculated,
      isInternationalShipping,
      currencyAttributes,
      orderType,
      isPlccICPickupModalOpen,
      IsPlccICAddressModalOpen,
      plccLoginModalState,
      freeShippingThresholdValue,
      freeShippingThreshold,
      productTotal,
      orderSubtotalEnhancementEnabled,
      bossInEligible,
      isFreeShippingCouponApplied,
      freeShippingPromoType,
      shipments,
      orderTrackingEnhancementEnabled,
    ]
  );

  const showPlccBanner =
    isShowLoyaltyBanner && !isPlccCheckoutEnabled && !isStickyCheckoutButtonEnabled;
  return (
    <>
      <div>
        <div
          className={`${className} ${spc ? '' : 'elem-mb-MED'} ${
            newBag ? 'rounded-container' : ''
          } ${isConfirmationPage ? 'order-confirmation' : ''} ${containerClass}`}
        >
          <Col
            className={spc ? 'spc-order-ledger-col' : ''}
            colSize={{
              large: 12,
              medium: 8,
              small: 6,
            }}
            ignoreGutter={{ small: true }}
          >
            {!isConfirmationPage && !spc && orderSubtotalEnhancementEnabled && (
              <BodyCopy
                fontWeight="bold"
                component="span"
                className="summary-heading elem-mb-MED"
                fontFamily="secondary"
              >
                {checkoutLabels.bagPage?.lbl_orderledger_title}
              </BodyCopy>
            )}
            <CollapsibleContainer
              className={`${showAccordian ? 'orderLedgerAccordian ' : 'elem-mt-MED'}`}
              header={header}
              body={body}
              iconLocator="arrowicon"
              defaultOpen={defaultOpen}
              isDefaultView={!showAccordian}
              showHeaderAlways={isConfirmationPage || spc}
              spc={spc}
              transitionConfig={
                spc ? SPC_SECTION_TRANSITION_CONFIG[SPC_SECTION.ORDER_SUMMARY] : undefined
              }
              isCollapseDisabled={isCollapseDisabled}
              isUserLoggedIn={isLoggedIn}
              isPlacePerkEnabled={isPlacePerkEnabled}
            />
          </Col>
        </div>
      </div>
      {showPlccBanner && renderPlccBanner(className, newBag, pageCategory)}
    </>
  );
};

OrderLedger.propTypes = {
  className: PropTypes.string.isRequired,
  bagLoading: PropTypes.bool,
  ledgerSummaryData: PropTypes.shape({
    itemsCount: PropTypes.number.isRequired,
    grandTotal: PropTypes.number,
    savingsTotal: PropTypes.number,
    subTotal: PropTypes.number,
    taxesTotal: PropTypes.number,
    couponsTotal: PropTypes.number,
    shippingTotal: PropTypes.number,
    giftCardsTotal: PropTypes.number,
    currencySymbol: PropTypes.string.isRequired,
    orderBalanceTotal: PropTypes.number,
    totalOrderSavings: PropTypes.number,
  }),
  pageCategory: PropTypes.string,
  orderLedgerAfterView: PropTypes.shape({}).isRequired,
  showAccordian: PropTypes.bool.isRequired,
  isConfirmationPage: PropTypes.bool,
  confirmationPageLedgerSummaryData: PropTypes.shape({
    itemsCount: PropTypes.number.isRequired,
    grandTotal: PropTypes.number,
    savingsTotal: PropTypes.number,
    subTotal: PropTypes.number,
    taxesTotal: PropTypes.number,
    couponsTotal: PropTypes.number,
    shippingTotal: PropTypes.number,
    giftCardsTotal: PropTypes.number,
    currencySymbol: PropTypes.string.isRequired,
    orderBalanceTotal: PropTypes.number,
    totalOrderSavings: PropTypes.number,
  }),
  trackAnalyticClick: PropTypes.func.isRequired,
  isVenmoPaymentInProgress: PropTypes.bool,
  venmoPayment: PropTypes.shape({}),
  spc: PropTypes.bool,
  spcBag: PropTypes.bool,
  isCollapseDisabled: PropTypes.bool.isRequired,
  isCartLoading: PropTypes.bool.isRequired,
  newBag: PropTypes.bool,
  isStickyCheckoutButtonEnabled: PropTypes.bool,
  isABTestLoaded: PropTypes.bool,
  orderType: PropTypes.string,
  storeAdress: PropTypes.shape({}),
  isLoggedIn: PropTypes.bool,
  userContactInfo: PropTypes.shape({}),
  isPlccCheckoutEnabled: PropTypes.bool,
  userName: PropTypes.string,
  isPlccCheckoutEnabledSwitch: PropTypes.bool,
  isPlccIsShippingAddressModalOpenAtn: PropTypes.func,
  IsPlccICAddressModalOpen: PropTypes.bool,
  handlePlccCheckout: PropTypes.func,
  userShippingAddress: PropTypes.shape({}),
  rememberedUserFlag: PropTypes.bool,
  containsExtendedOrder: PropTypes.bool,
};

OrderLedger.defaultProps = {
  ledgerSummaryData: {},
  confirmationPageLedgerSummaryData: {},
  isConfirmationPage: false,
  pageCategory: '',
  bagLoading: false,
  isVenmoPaymentInProgress: false,
  venmoPayment: {
    userName: '',
    ccBrand: 'venmo',
    ccType: 'venmo',
  },
  spc: false,
  spcBag: false,
  newBag: false,
  isABTestLoaded: false,
  orderType: '',
  storeAdress: {},
  isLoggedIn: false,
  userContactInfo: {},
  isPlccCheckoutEnabled: false,
  userName: '',
  isPlccCheckoutEnabledSwitch: false,
  isPlccIsShippingAddressModalOpenAtn: () => {},
  IsPlccICAddressModalOpen: false,
  handlePlccCheckout: () => {},
  userShippingAddress: {},
  rememberedUserFlag: false,
  containsExtendedOrder: false,
};
export default withStyles(OrderLedger, styles);
export { OrderLedger as OrderLedgerVanilla };
